import { render } from "./SimpleColorPicker.vue?vue&type=template&id=4f348c24&scoped=true"
import script from "./SimpleColorPicker.vue?vue&type=script&lang=ts"
export * from "./SimpleColorPicker.vue?vue&type=script&lang=ts"

import "./SimpleColorPicker.vue?vue&type=style&index=0&id=4f348c24&lang=scss"
import "./SimpleColorPicker.vue?vue&type=style&index=1&id=4f348c24&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4f348c24"

export default script